import React from 'react';
import './WhoWeAre.css';
import { useNavigate } from "react-router-dom";
import hero1 from "./Images/Wp1.jpg";
import hero2 from "./Images/Wp2.jpg";
const WhoWeAre = () => {
    const navigate = useNavigate();

    // Real Estate images
    const realEstateImages = [
        {
            id: 1,
            url: hero1,
            title: "Luxury Residential Villa",
            category: "Residential"
        },
        {
            id: 2,
            url: hero2,
            title: "Premium Commercial Space",
            category: "Commercial"
        }
    ];

    return (
        <div className="who-we-are-container">
            <div className="main-layout">
                {/* Left Content Section - 60% width */}
                <div className="left-content">
                    <div className="header-section">
                        <div className="accent-bar"></div>
                        <h1 className="main-title">Premium Real Estate Partners</h1>
                        <div className="organization-tag">Since 2001</div>
                    </div>

                    <div className="description-section">
                        <p className="description-text">
                            Established in 2001, we bring over two decades of strong offline experience in the real estate
                            industry, now transformed into a modern digital platform. BG RealEstate360 is built on deep
                            market knowledge, long-term relationships, and a commitment to delivering reliable property
                            solutions across Gujarat’s key industrial regions.
                        </p>

                        <p className="description-text">
                            We specialize in industrial land, GIDC plots, warehouses, factories, and commercial properties,
                            along with selective residential projects. Our core operational areas include Ankleshwar,
                            Dahej, Jhagadia, Panoli, and the entire Bharuch district—regions known for high industrial
                            growth and strategic investment potential.
                        </p>

                        <p className="description-text">
                            Our mission is to simplify property transactions through transparency, strategic guidance,
                            and customer-first service. By combining our strong offline foundation with digital innovation,
                            we help clients make confident decisions, create long-term value, and grow with trust.
                        </p>
                    </div>


                    {/* Services Highlight */}
                    <div className="services-section">
                        <div className="services-grid">

                            {/* Industrial */}
                            <div className="service-card">
                                <div className="service-icon">🏭</div>
                                <div className="service-content">
                                    <h4>Industrial Properties</h4>
                                    <p>Industrial land, factories, warehouses, and GIDC plots</p>
                                </div>
                            </div>

                            {/* Commercial */}
                            <div className="service-card">
                                <div className="service-icon">🏢</div>
                                <div className="service-content">
                                    <h4>Commercial Spaces</h4>
                                    <p>Office buildings, retail spaces, and commercial complexes</p>
                                </div>
                            </div>

                            {/* Residential */}
                            <div className="service-card">
                                <div className="service-icon">🏠</div>
                                <div className="service-content">
                                    <h4>Residential Properties</h4>
                                    <p>Apartments, villas, and premium residential projects</p>
                                </div>
                            </div>

                            {/* Plot & Land Properties */}
                            <div className="service-card">
                                <div className="service-icon">🌳</div>  {/* Land / Plot icon */}
                                <div className="service-content">
                                    <h4>Land & Plot Properties</h4>
                                    <p>Residential, commercial, and agricultural land & plots available for investment</p>
                                </div>
                            </div>


                        </div>
                    </div>


                    {/* Call to Action */}

                   
                    <div className="cta-section">
                        <button className="cta-button" onClick={() => navigate("/propertie")}>
                            <span>Explore Properties</span>
                            <svg className="arrow-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M4.16666 10H15.8333M15.8333 10L10 4.16666M15.8333 10L10 15.8333"
                                    stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
                                    strokeLinejoin="round" />
                            </svg>
                        </button>
                    </div>

                    {/* Real Estate Statistics */}
                    <div className="stats-section">
                        <div className="stats-grid">
                            <div className="stat-card">
                                <div className="stat-content">
                                    <div className="stat-number">500+</div>
                                    <div className="stat-label">Properties Sold</div>
                                    <div className="stat-desc">Happy Customers</div>
                                </div>
                            </div>

                            <div className="stat-card displaynone">
                                <div className="stat-content">
                                    <div className="stat-number">300+</div>
                                    <div className="stat-label">Active Listings</div>
                                    <div className="stat-desc"> Residential & Commercial
</div>
                                </div>
                            </div>

                            <div className="stat-card">
                                <div className="stat-content">
                                    <div className="stat-number">15+</div>
                                    <div className="stat-label">Projects Completed</div>
                                    <div className="stat-desc">Across Cities</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right Images Section - 40% width with small images */}


               

                <div className="right-images-section">
                    <div className="images-stack">
                        {realEstateImages.map((property) => (
                            <div key={property.id} className="image-frame">
                                <img
                                    src={property.url}
                                    alt={property.title}
                                    className="property-image-simple"
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WhoWeAre;